export default "__VITE_ASSET__f478ce33__"